// Legacy JS bundle。`javascript_include_tag "legacy"` で全レイアウトが読む。
// jQuery / bootstrap-select は撤去済み (#2428)。残るのは vanilla ES のみ。

// .selectpicker を Tom Select 化する(銀行/支店の検索付きプルダウン)。
import "./selectpicker-init";

// 給与編集ページ(app バンドルを読まない)向けに BS5 Modal を配線する。
import "./bootstrap-modal";

import axios from "axios";
window.axios = axios;

// 旧 require_tree 相当。
import "./paybook";
import "./user";
import "./companies/users/new";
import "./admin/lias";
import "./admin/broadcasts";
